import { Component, Prop, Vue } from 'vue-property-decorator'
import { KFormSelect } from '@kwixeo/form-vue'
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'

@Component({
  components: {
    KFormSelect,
    BRow, BCol, BFormGroup
  }
})
export default class ProductVariationView extends Vue {
  @Prop({ default: null }) value!: KwixeoCatalog.CommandContent|KwixeoCatalog.StockManualMovementContent
}
